module.exports = __webpack_public_path__ + "img/logo_UEEx.6b273df3.png";